/**
 * 基础信息 房型
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>房型管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" v-if="$canManage()" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="attributeName" label="房型名称" width="150">
      </el-table-column>
      <el-table-column sortable prop="guidePrice" label="指导价" width="150">
      </el-table-column>
      <el-table-column sortable prop="resided" label="已住(间)" width="150">
      </el-table-column>
      <el-table-column sortable prop="vacant" label="空房(间)" width="150">
      </el-table-column>
      <el-table-column sortable prop="total" label="共计(间)" width="150">
      </el-table-column>
      <el-table-column sortable prop="occupancyRate" label="入住率" :formatter="(row) => formatOccupancyRate(row.occupancyRate)" width="150">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" v-if="$canManage()" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" v-if="$canManage()" @click="deleteRoomAttribute(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="房型名称" prop="attributeName">
          <el-input size="small" v-model="editForm.attributeName" auto-complete="off" placeholder="请输入房型名称"></el-input>
        </el-form-item>
        <el-form-item label="指导价" prop="guidePrice">
          <el-input size="small" v-model="editForm.guidePrice" auto-complete="off" placeholder="请输入指导价"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {deleteAttribute, roomAttribute, roomAttributeSave} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        id:'',
        attributeName: '',
        guidePrice: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        attributeName: [
          { required: true, message: '请输入房型名称', trigger: 'blur' }
        ],
        guidePrice: [{ required: true, message: '请输入指导价', trigger: 'blur' }]
      },
      formInline: {
        current: 1,
        size: 10,
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      roomAttribute(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })

    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.attributeName = row.attributeName
        this.editForm.guidePrice = row.guidePrice
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.attributeName = ''
        this.editForm.guidePrice = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          roomAttributeSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code==='200') {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '房型成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除房型
    deleteRoomAttribute(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteAttribute([row.id])
            .then(res => {
              if (res.code==='200') {
                this.$message({
                  type: 'success',
                  message: '房型已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('房型删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },// 格式化百分比
    formatOccupancyRate(value){
      return value*100+" %"
    },// 变动数额计算合计数额
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/basic/RoomAttribute.vue